import { DieselRingColors } from './enums';

export {
  DieselRingType,
  getEngravingKey,
  DieselRingColors,
  DieselRingSizes,
  DieselRingPriceData,
  MiscDieselRingCheckoutTypes,
  DIESEL_RING_STATIC_SHIPPING,
  DEFAULT_PRICE_STRIKED_STORES,
} from './enums';
export type { DieselRingVariantType } from './enums';

// Color display names
export const DieselRingColorNameImages: Record<
  DieselRingColors,
  Record<string, string | null | React.ReactNode>
> = {
  [DieselRingColors.CRYO]: {
    image: 'web_v2/uh-x-diesel/buy-page/color-cta/cryo.png/w_400',
    name: 'Cryo',
    tag: null,
  },
  [DieselRingColors.PHANTOM]: {
    image: 'web_v2/uh-x-diesel/buy-page/color-cta/phantom.png/w_400',
    name: 'Phantom',
    tag: null,
  },
};

// Large images for order tracking page
export const DieselRingColorNameLargeImages: Record<
  DieselRingColors,
  Record<string, string | null>
> = {
  [DieselRingColors.CRYO]: {
    image: 'web_v2/uh-x-diesel/buy-page/color-cta/cryo.png/w_1000',
    shop: `web_v2/shop/diesel/cryo.png`,
    name: 'Cryo',
    tag: null,
  },
  [DieselRingColors.PHANTOM]: {
    image: 'web_v2/uh-x-diesel/buy-page/color-cta/phantom.png/w_1000',
    shop: `web_v2/shop/diesel/phantom.png`,
    name: 'Phantom',
    tag: null,
  },
};

// Helper to get color tag
export const getDieselRingColorTag = (color: DieselRingColors) => {
  return DieselRingColorNameImages[color].tag;
};
